module.exports = __webpack_public_path__ + "img/DC3E04_B52604_FC7D20_F85F04-256px.4859acb9.png";